import React from 'react';
import Button from "./Button";
import { ButtonClass } from "../enums/ButtonClass";

type BackButtonProps = {
    onClick?: (e: Event) => void,
    children?: React.ReactNode
}

const BackButton = (props: BackButtonProps) => {
    return (
        <Button mainButtonClass={ButtonClass.DEFAULT}
                buttonContent={<span>Back</span>}
                onClick={props.onClick}/>
    )
};
export default BackButton;